import { useContacts } from '@entities/contacts';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { ContactsList } from '@widgets/contacts';
import { Add } from '@shared/assets';
import { useUser } from '@shared/hooks';
import { Card, IconButton } from '@shared/ui';
import { Loader } from '@src/library/components/common';
import * as st from './styles.module.scss';

interface Props {
  onRedirect?: () => void;
  contacts?: number[];
}

export const Contacts: React.FC<Props> = ({ onRedirect, contacts }) => {
  const { user } = useUser();
  const { isLoading: isLoadingContacts, setSelectedContacts, selectedContacts } = useContacts();
  const hasSelectedContact = selectedContacts.length > 0;

  const [userId, setUserId] = useState(0);
  const navigate = useNavigate();
  const {
    setValue,
    // getValues,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    if (user?.id) {
      setUserId(user.id);
    }
  }, []);

  useEffect(() => {
    if (contacts && contacts.length && !hasSelectedContact) {
      setSelectedContacts(contacts);
    }
  }, [contacts]);

  useEffect(() => {
    if (hasSelectedContact) {
      setValue('contacts', selectedContacts);
    }
  }, [setSelectedContacts, setValue]);

  const handleAddContacts = () => {
    // localStorage.setItem('eventEditorFormState', JSON.stringify(getValues()));
    if (userId > 0) {
      localStorage.setItem('userId', `${userId}`);
      onRedirect && onRedirect();
      navigate('/contacts');
    }
  };

  return (
    <div className={st.contacts}>
      <div className={`${st.contacts__header} ${!hasSelectedContact ? st.column : ''}`}>
        <div>
          {errors?.contacts ? (
            <span className={st.errorSpan}>{errors.contacts?.message as string}</span>
          ) : null}
          <h3>Контакты для клиентов</h3>
        </div>
        {hasSelectedContact ? (
          <IconButton
            className={st.contacts__addBtn}
            variant="white"
            type="button"
            onClick={handleAddContacts}
            title="Добавить контакт из списка контактов"
          >
            <Add />
          </IconButton>
        ) : (
          <Card className={st.bigAddBtn} onClick={handleAddContacts}>
            <IconButton
              className={st.contacts__deleteBtn}
              variant="dark"
              type="button"
              title="Добавить контакт из списка контактов"
            >
              <Add />
            </IconButton>
            <span>Добавить</span>
          </Card>
        )}
      </div>
      {isLoadingContacts ? <Loader /> : <ContactsList isSelectedList={false} />}
    </div>
  );
};
